import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  page: 1,
  pageSize: 24,
  agentCount: 0,
  isFetching: false,
  isFetched: false,
  isFetchedDefault: false,
  isFetchEnd: false,
  error: null,
  agents: [],
  filters: {
    districts: [],
    emp_type: [],
  },
  query: {},
};

export default {
  namespaced: true,

  state,
  mutations,
  actions,
  getters,
};
